"use client";

import type { ReactNode } from "react";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/lib/components/tabs";

/**
 * Tab wrapper for a model detail page's sections. The server page renders each
 * section and passes it in as a slot, so no data needs to move to the client —
 * this component only owns the active-tab state. Same tab style as the Smart
 * Router / Organization Settings pages. Mobile-responsive: the tab bar scrolls
 * horizontally on narrow screens.
 */
export function ModelSectionTabs({
	overview,
	capabilities,
	providers,
}: {
	overview: ReactNode;
	capabilities: ReactNode;
	providers: ReactNode;
}) {
	return (
		<Tabs defaultValue="overview" className="w-full space-y-6">
			<TabsList className="h-9 max-w-full overflow-x-auto">
				<TabsTrigger value="overview" className="px-4 text-xs">
					Overview
				</TabsTrigger>
				<TabsTrigger value="capabilities" className="px-4 text-xs">
					Capabilities
				</TabsTrigger>
				<TabsTrigger value="providers" className="px-4 text-xs">
					Providers
				</TabsTrigger>
			</TabsList>

			<TabsContent value="overview" className="mt-0">
				{overview}
			</TabsContent>
			<TabsContent value="capabilities" className="mt-0">
				{capabilities}
			</TabsContent>
			<TabsContent value="providers" className="mt-0">
				{providers}
			</TabsContent>
		</Tabs>
	);
}
